import { MessageBox } from 'mint-ui'

var MINT_DEFAULT = {
  title: '提示'
}
var MintMessageBox = function (options) {
  if (typeof (options) === 'object') {
    options = Object.assign({}, MINT_DEFAULT, options)
  }
  MessageBox(options)
}

export default MintMessageBox



// WEBPACK FOOTER //
// ./src/third/MsgBox.js